<template>
  <div id="Lgx02668426028919138812513">
    <div class="relative flex flex-col main-border rounded-lg bg-dark p-10">
      <span class="mb-10 space-x-4">
        <vs-button size="small" :class="activeTab !== 0 && 'text-black'" :color="activeTab == 0 ? 'primary' : 'dark'" @click="activeTab = 0"
          >Network Health</vs-button
        >
        <vs-button size="small" :class="activeTab !== 1 && 'text-black'" :color="activeTab == 1 ? 'primary' : 'dark'" @click="activeTab = 1"
          >Device Monitoring</vs-button
        >
      </span>

      <div v-if="activeTab === 0">
        <img
          src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02668426028919138812513/graphic.png"
          alt="Logo"
          draggable="false"
          width="100%"
        />

        <span class="image" style="width: 24%; height: 29.5%; bottom: 59%; left: 3%" @click="popups[0].open = true" />
        <span class="image" style="width: 68.5%; height: 29.5%; bottom: 59%; left: 28.5%" @click="popups[1].open = true" />
        <span class="image" style="width: 29%; height: 24.5%; bottom: 28.5%; left: 2.9%" @click="popups[2].open = true" />
        <span class="image" style="width: 29%; height: 24.5%; bottom: 28.5%; left: 35.5%" @click="popups[3].open = true" />
        <span class="image" style="width: 29%; height: 24.5%; bottom: 28.5%; left: 68%" @click="popups[4].open = true" />
        <span class="image" style="width: 94%; height: 10%; bottom: 12%; left: 2.9%" @click="popups[5].open = true" />

        <span class="flex items-center gap-10 mt-8">
          <h3>Which WAN station should be preferred for VoIP traffic?</h3>
          <v-select class="w-48" id="select-0" :options="['WAN 1', 'WAN 2']" v-model="answers[0].value" placeholder="Select WAN" />
        </span>
      </div>

      <div v-else>
        <img
          src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02668426028919138812513/graphic-alt.png"
          alt="Logo"
          draggable="false"
          width="85%"
        />

        <span class="image" style="width: 38%; height: 55%; bottom: 28.8%; left: 3%" @click="popups[6].open = true" />
        <span class="image" style="width: 38.2%; height: 48.7%; bottom: 34.8%; left: 44.8%" @click="popups[7].open = true" />

        <span class="flex items-center mt-8">
          <h3 style="width: 42rem">Which device is experiencing connectivity issues?</h3>
          <v-select class="w-64" id="select-1" :options="deviceOptions" v-model="answers[1].value" placeholder="Select Device" />
        </span>

        <span class="flex items-center mt-8">
          <h3 style="width: 42rem">Which workstation IP is generating the MOST traffic?</h3>
          <v-select class="w-64" id="select-2" :options="ipOptions" v-model="answers[2].value" placeholder="Select IP Address" />
        </span>
      </div>
    </div>

    <movable-popup
      v-for="(popup, index) in popups"
      :key="index"
      refVal="imagePopup"
      :title="popup.title"
      :active="popup.open"
      v-on:close="popup.open = false"
      style="width: fit-content"
    >
      <template v-slot:content>
        <div class="flex flex-col gap-3">
          <img
            :src="`https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02668426028919138812513/individual/${popup.image}`"
            alt="Logo"
            draggable="false"
            width="100%"
          />
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      activeTab: 0,

      popups: [
        {
          title: 'Wireless Client Distribution',
          image: 'wcd.png',
          open: false,
        },
        {
          title: 'Wireless Users Connected - 24 Hours',
          image: 'wuc.png',
          open: false,
        },
        {
          title: 'RAM Usage',
          image: 'ram.png',
          open: false,
        },
        {
          title: 'Processor Usage',
          image: 'processor.png',
          open: false,
        },
        {
          title: 'WAN Health',
          image: 'wan.png',
          open: false,
        },
        {
          title: 'WAN Uplinks',
          image: 'wan-uplinks.png',
          open: false,
        },
        {
          title: 'Device Status',
          image: 'device-status.png',
          open: false,
        },
        {
          title: 'Top Hosts',
          image: 'top-hosts.png',
          open: false,
        },
      ],

      deviceOptions: [
        'Router A',
        'Router B',
        'WAP1',
        'WAP2',
        'Wireless Controller',
        'Switch A',
        'Switch B',
        'DHCP Server',
        'Web Server',
        'App Server',
      ],

      ipOptions: [
        '10.1.99.28',
        '10.1.99.14',
        '10.1.99.10',
        '10.1.99.22',
        '10.1.99.24',
        '206.208.133.10',
        '206.208.133.9',
        '10.1.50.14',
        '10.1.50.13',
        '10.1.59.81',
        '10.1.90.53',
        '10.1.90.55',
      ],

      answers: [
        {
          value: null,
          answer: 'WAN 2',
        },
        {
          value: null,
          answer: 'Router A',
        },
        {
          value: null,
          answer: '10.1.90.53',
        },
      ],
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      this.answers.forEach((answer, index) => {
        const selectElement = document.querySelector(`#select-${index}`);

        if (answer.value === answer.answer) {
          if (selectElement) selectElement.classList.add('correct-border');
          totalScore++;
        } else {
          if (selectElement) selectElement.classList.add('invalid-border');
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
#Lgx02668426028919138812513 {
  .image {
    position: absolute;
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto;
  }

  .correct-border {
    border: 1px solid #31b952 !important;
  }

  .invalid-border {
    border: 1px solid #c93738 !important;
  }
}
</style>
